import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule],
})
export class LoadingSpinnerComponent implements OnInit {
  constructor() { }
  @Input() backdrop: boolean | null = true || null;
  @Input() smallSize: boolean | null = false || null;
  @Input() name: string = 'crescent';
  @Input() color: string = 'recog-coconut';
  @Input() size: string = '30';
  @Input() smallerSpinner: boolean = false;
  @Input() centered: boolean = false;

  ngOnInit() { }
}
